import { AUDIENCES } from "@/lib/content";
import { Reveal } from "./Reveal";

export const WhoWeServe = () => (
  <section id="who-we-serve" className="bg-sage text-pine py-24 md:py-32" data-testid="who-we-serve-section">
    <div className="max-w-6xl mx-auto px-6">
      <Reveal>
        <h2 className="dp">Wherever you are <em>in it</em></h2>
      </Reveal>
      <div className="mt-12 grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
        {AUDIENCES.map((a, i) => (
          <Reveal key={a.label} delay={(i % 3) * 100} className={i % 2 === 1 ? "md:mt-12" : ""}>
            <figure className="group relative aspect-[4/5] overflow-hidden bg-mist-1" data-testid={`audience-card-${i}`}>
              <img
                src={a.img}
                alt={a.label}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
              />
              <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-pine/70 to-transparent" aria-hidden="true" />
              <figcaption className="absolute bottom-4 left-4 right-4 lb text-sage leading-snug">{a.label}</figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
